<template>
    <div class="vsebina ">

        <div class="glava_vsebine adapt v-adapt">

            <div class="cols">
                <div class="col left grid-col-6">
                    <h1>Dejavnosti</h1>
                </div>



                <div class="col right">
                </div>

            </div>
        </div>

        <div class="telo_vsebine adapt v-adapt">
            <div>
                <div :style="{ display: 'inline-block' }">
                    Sezona
                    <br />
                    <dropdownlist :data-items="sezoneBranje" :text-field="'sezona'" @change="sezonaChange"
                        :value="dataSezona" />

                </div>
            </div>

            <div class="uporabnik-spacer" style="margin-top:2rem"></div>
            <div class="columnBar">
                <kendo-multiselect :data-source="columns" :data-text-field="'title'" :data-value-field="'field'"
                    :placeholder="'Skrij stolpce'" @select="skrijStolpec" @deselect="prikaziStolpec"
                    :filter="'contains'" :auto-width="true" :value="hiddenColumns">
                </kendo-multiselect>
            </div>
            <div class="grid-wrapper">
                <Grid :sortable="sortable" :filterable="filterable"
                    :pageable="{ buttonCount: 4, pageSizes: [10, 50, 100, 'all'] }" :data-items="dataResult" :skip="skip"
                    :take="take" :sort="sort" :resizable="true" :filter="filter" :columns="columns" @columnresize="columnresize"
                    @datastatechange="dataStateChange" @pagechange="pageChangeHandler">

                    <template v-slot:nogaStSubj="{ props }">
                        <span>{{ nogaStSubj() }}</span>
                    </template>
                    <template v-slot:nogaVsotaKolicina="{ props }">
                        <span>{{ nogaVsotaKolicina() }}</span>
                    </template>

                    <template v-slot:cbItem="{ props }">
                        <cbItem :checked="props.dataItem.jeglavna" />
                    </template>
                    <toolbar>

                        <div class="km-widget km-buttongroup k-widget k-button-group">
                            <button title="Išči" class="k-button k-primary" @click="naloziPodatke">
                                Išči
                            </button>
                            <button title="Export to Excel" class="k-button k-primary" @click="exportExcel">
                                Izvozi v Excel
                            </button>
                        </div>

                    </toolbar>
                </Grid>
                <div class="shema-loader" v-if="loading"><font-awesome-icon icon="circle-notch" spin="spin" /></div>
            </div>
        </div>
    </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
//import '@progress/kendo-ui' // This will import the entire Kendo UI library
import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';
import { Grid, GridToolbar } from '@progress/kendo-vue-grid';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import { saveExcel } from '@progress/kendo-vue-excel-export';
import { MultiSelect } from '@progress/kendo-dropdowns-vue-wrapper';
Vue.component('kendo-multiselect', MultiSelect);
import CheckBoxGridItem from './support/CheckBoxGridItem';

import { process } from '@progress/kendo-data-query';





Vue.component('Grid', Grid);
Vue.component('toolbar', GridToolbar);
Vue.component('dropdownlist', DropDownList);



export default {
    props: ['sezona'],
    components: {

        'cbItem': CheckBoxGridItem
    },
    data() {
        return {

            dataSezona: this.sezona,
            loading: false,



            filter: null,
            editID: null,
            skip: 0,
            take: 10,
            pageSize: 10,
            sortable: true,
            filterable: true,
            groupable: false,
            dataResult: [],

            sort: [
                //{ field: 'vrstakulture', dir: 'asc' }
            ],





        }
    },
    created() {





        if (!this.sezona)
            this.dataSezona = { sezona: Math.max(...this.sezoneBranje.map(s => s.sezona)) };
        else
            this.dataSezona = { sezona: this.sezona };
        //     this.loadVse({sezona:this.dataSezona.sezona});

        this.getState()
    },
    beforeRouteLeave(to, from, next) {
        console.log("SHRANIM STANJE!");
        this.saveState();
        next()


    },
    computed: {
        columns() {
            var columns = [


                { field: "naziv", title: "Proizvod" },//,footerCell: this.nogaNazivVsot},
                { field: "skupinadejavnosti", title: "Skupina proizvodov" },
                { field: "vrstadejavnosti", title: "Vrsta proizvodov" },
                { field: "kolicina", title: "Količina", width: "100px", filterable: false, type: "number", footerCell: 'nogaVsotaKolicina', width: "150px", format: '{0:n2}' },
                { field: "merskaenotanaziv", title: "Enota", width: "100px", filterable: false },
                { field: "jeglavna", title: "Glavna", width: "100px", filterable: true, cell: "cbItem" },
                //{ field: "enota", title:"Enota", type:"string",filterable:false,width: "80px"},
                { field: "veljavnostcertifikataod", filterable: false, title: "Datum določitve statusa", width: "170px", type: "date", format: "{0:d}", hidden: true },
                //template: "#= kendo.toString(kendo.parseDate(veljavnostcertifikataod, 'yyyy-MM-dd'), 'MM/dd/yyyy') #"},
                //filter:'date',format: "{0:d}"},
                // { field: "veljavnostcertifikatado", title:"Veljavnost statusa", type:"string",editor: 'date',width: "150px",format: '{0:d}'},

                { field: "statusdejavnostinaziv", title: "Status", width: "150px" },

                { field: "nazivpredelovalca", title: "Naziv predelovalca", width: "150px", hidden: false, footerCell: 'nogaStSubj' },
                //{ field: "kontrolnastevilka", title:"Kontrolna št.",width: "150px"},
                { field: "kontrolnastevilka", title: "Kontrolna št.", width: "150px" },
                { field: "status", title: "Status predelovalca", width: "150px", hidden: true },

                { field: "postnastevilka", title: "Poštna številka", hidden: true },
                { field: "posta", title: "Pošta", hidden: true },
                { field: "obcina", title: "Občina", hidden: true },
                { field: "statisticnaregija", title: "Statistična regija", hidden: true },


            ];
            if (this.userDetails.pravice.includes("STATISTIKA_BERI"))
                columns.push({ field: "kontrolnaorganizacija", title: "V kontroli pri" });

            return columns;
        },
        hiddenColumns() {
            return this.columns.filter(c => c.hidden);
        },
        ...mapState('users', ['userDetails', 'sezoneBranje']),
        ...mapState({
            gridData(state) {

                return state.dejavnost.dejavnost;
            }
        }),

    },
    watch: {
        skip(newValue, oldValue) {
            console.log(`Updating from ${oldValue} to ${newValue}`);

            const dataState = {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                group: this.group
            };
            this.dataResult = process(this.gridData, dataState);
        },
        take(newValue, oldValue) {
            console.log(`Updating from ${oldValue} to ${newValue}`);

            const dataState = {
                skip: this.skip,
                take: this.take,
                filter: this.filter,
                sort: this.sort,
                group: this.group
            }
            this.dataResult = process(this.gridData, dataState);
        },
        gridData(newValue, oldValue) {


            if (newValue) {
                const dataState = {
                    skip: this.skip,
                    take: this.take,
                    sort: this.sort,
                    filter: this.filter,
                    group: this.group
                };
                this.dataResult = process(this.gridData, dataState);

            }
        }
    },
    methods: {

        ...mapActions('dejavnost', ['loadVse']),
        saveState: function () {
            const gridState = {};
            //gridState.data = [...this.gridData];
            gridState.sortable = this.sortable;
            gridState.filterable = this.filterable;
            gridState.groupable = this.groupable;
            gridState.skip = this.skip;
            gridState.take = this.take;
            gridState.group = this.group;
            gridState.sort = this.sort;
            gridState.filter = this.filter;
            gridState.columns = this.columns;
            gridState.sezona = this.dataSezona;

            localStorage.setItem('dejavnostiState' + this.$version, JSON.stringify(gridState));
        },
        getState: function () {
            const gridState = JSON.parse(localStorage.getItem('dejavnostiState' + this.$version));

            if (gridState !== null) {
                //this.gridData = gridState.data;
                this.sortable = gridState.sortable;
                this.filterable = gridState.filterable;
                this.groupable = gridState.groupable;
                this.skip = gridState.skip;
                this.take = gridState.take;
                this.group = gridState.group;
                this.sort = gridState.sort;
                this.filter = gridState.filter;
                this.columns = gridState.columns;
                this.dataSezona = gridState.sezona;
                this.dataResult = process(this.gridData, {
                    skip: this.skip,
                    take: this.take,
                    sort: this.sort,
                    filter: this.filter,
                    group: this.group,
                });
            }
        },
        columnresize: function (e) {
            if (e.end) {
                let column = e.columns[e.index];
                let sc = this.columns.find(c => c.field == column.field)

                sc.width = e.newWidth;

            }
        },
        naloziPodatke: async function (e) {
            this.loading = true;
            if (!this.sezona) {
                this.dataSezona = { sezona: Math.max(...this.sezoneBranje.map(s => s.sezona)) };
                this.sezona = this.dataSezona.sezona;
            }
            else
                this.dataSezona = { sezona: this.sezona };
            this.loadVse(this.dataSezona).then(() => this.loading = false);
        },
        skrijStolpec: function (e) {
            let column = this.columns.find(c => c.field == e.dataItem.field)
            if (column)
                column.hidden = true;
            const dataState = {
                skip: this.skip,
                take: this.take,
                filter: this.filter,
                sort: this.sort,
                group: this.group
            };
            this.dataResult = process(this.gridData, dataState);

        },
        prikaziStolpec: function (e) {
            let column = this.columns.find(c => c.field == e.dataItem.field)
            if (column)
                column.hidden = false;
            const dataState = {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                filter: this.filter,
                group: this.group
            };
            this.dataResult = process(this.gridData, dataState);
        },
        nogaNazivVsot: function (h, emptyElement, props, listeners) {
            return h('span', {}, ['Vsota/število unikatnih MID-ov:']);
        },
        nogaVsotaKolicina: function () {
            if (this.dataResult.data) {
                const dataState = {
                    filter: this.filter
                };
                let data = process(this.gridData, dataState).data;
                return kendo.toString(data.reduce((acc, current) => acc += current.kolicina, 0), "n2");
            }
        },

        nogaStSubj: function () {
            if (this.dataResult.data) {
                var counts = {};
                const dataState = {
                    filter: this.filter
                };
                let data = process(this.gridData, dataState).data;
                for (var i = 0; i < data.length; i++) {
                    //    console.log(this.dataResult.data[i]);
                    counts[data[i]['subjid']] = 1 + (counts[data[i]['subjid']] || 0);
                }
                return "Število unikatnih predelovalcev: " + kendo.toString(Object.keys(counts).length, "n0");
            }

        },
        formatDate: function (h, emptyElement, props, listeners) {

            return h('td', { attrs: { colspan: 1 } }, [kendo.toString(kendo.parseDate(props.dataItem.veljavnostcertifikataod), 'd')]);
        },



        sezonaChange(event) {
            const sezona = event.value;
            this.dataSezona = sezona;

            this.$router.push({ name: 'dejavnosti', params: { sezona: sezona.sezona } })
            this.dataSezona = sezona;
            // this.loadVse(this.dataSezona);



        },


        createAppState: function (dataState) {
            console.log("createAppState");
            this.take = dataState.take;
            this.skip = dataState.skip ? dataState.skip : 0;
            this.group = dataState.group;
            this.filter = dataState.filter;
            this.sort = dataState.sort;

        },

        dataStateChange(event) {
            console.log("DataStateChange");
            console.log(event);
            this.createAppState(event.data);

            this.dataResult = process(this.gridData, {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                filter: this.filter,
                group: this.group
            });


        },

        exportExcel() {
            this.saveExcel({
                data: process(this.gridData, { sort: this.sort, filter: this.filter }).data,
                fileName: this.dataSezona.sezona + "_DEJAVNOSTI",
                columns: this.columns.filter(i => !i.hidden)
            });
        },


        pageChangeHandler: function (event) {
            console.log(event);
            this.skip = event.page.skip;
            this.take = event.page.take;

        }

    }
};
</script>
